import { render, staticRenderFns } from "./DrawingConfig.vue?vue&type=template&id=7d23869f&scoped=true&"
import script from "./DrawingConfig.vue?vue&type=script&lang=js&"
export * from "./DrawingConfig.vue?vue&type=script&lang=js&"
import style0 from "./DrawingConfig.vue?vue&type=style&index=0&id=7d23869f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d23869f",
  null
  
)

export default component.exports